import _ from 'lodash';

/**
 *
 * @param {*} apiRequest
 * @returns {QueryFunction} a function that returns a promise
 */
const createQueryRequest = (apiRequest) => {
  return ({ queryKey, signal }) => {
    const newRequest = (...params) => apiRequest(signal, ...params);
    return newRequest(..._.tail(queryKey));
  };
};

export default createQueryRequest;
